module.exports = {
  site: {
    outputDir: 'dist/prod',
    routerBase: '/', // 网站路由基础路径
    routerMode: 'history',
    vconsole: false,
    visualScrollbar: true,
    sessionIDKey: 'sessionid',
    deviceIDKey: 'deviceid',
    pageRecordsKey: 'vkpage', // 记录当前页面名称到SS中的key
    bizKey: 'biz',
    langKey: 'lang',
    noLangPath: false, // 是否禁用语言路径
    bizs: {
      vn: {
        host: /topica|-vn\./i,
        langs: {
          'vi-vn': {
            text: 'Tiếng Việt',
            appLangCode: 11,
          },
        },
      },
      tc: {
        host: /thevipteacher/i,
        busEnable: true,
        langs: {
          'en-us': {
            text: 'English',
            appLangCode: 0,
          },
          'zh-cn': {
            text: '中文简体',
            appLangCode: 6,
          },
          'zh-hk': {
            text: '中文繁體',
            appLangCode: 1,
          },
        },
      },
      k2: {
        host: /^kr\.|-k2\./i,
        langs: {
          'ko-kr': {
            text: '한국어',
            appLangCode: 2,
          },
          'en-kr': {
            text: 'English',
            appLangCode: 0,
          },
        },
      },
      tw: {
        host: /^tw\.|-tw\./i,
        langs: {
          'zh-tw': {
            text: '中文繁體',
            appLangCode: 14,
          },
        },
      },
      ts: {
        host: /tiger|lionactivity|flameabc|blazingabc|-ts\./i,
        langs: {
          'en-us': {
            text: 'English',
            appLangCode: 0,
          },
          'zh-cn': {
            text: '中文简体',
            appLangCode: 6,
          },
        },
      },
      jp: {
        host: /^jp\.|-jp\./i,
        langs: {
          'ja-jp': {
            text: '日本語',
            appLangCode: 3,
          },
        },
      },
      ae: {
        host: /\.ae|-ae\.|ksa\.|-sa\./i,
        langs: {
          'ar-ae': {
            text: 'العربية',
            appLangCode: 15,
            dir: 'rtl',
          },
          'en-ae': {
            text: 'English',
            appLangCode: 16,
          },
        },
      },
      hk: {
        host: /\.vipkid\.|-hk\./i,
        langs: {
          'en-us': {
            text: 'English',
            appLangCode: 0,
          },
          'zh-cn': {
            text: '中文简体',
            appLangCode: 6,
          },
          'zh-hk': {
            text: '中文繁體',
            appLangCode: 1,
          },
        },
      },
    },
  },
  resources: {
    file: 'https://s.vipkidstatic.com/fe-static/int/translate/v2/{runtime}_{appName}_{lang}.js',
    cacheExpires: 10 * 60 * 1000, // 资源缓存刷新间隔时间（毫秒数）
    commonModule: 'app', // 全局公共模块名
    callbackMethod: 'HobbitResourcesCallback_{lang}', // 全局安装函数（JSONP用）
  },
  theme: true,
  // theme: {
  //   file: 'https://s.vipkidstatic.com/fe-static/int/theme/{appName}/{runtime}/{biz}.js',
  //   cacheExpires: 30 * 60 * 1000, // 资源缓存刷新间隔时间（毫秒数）
  //   callbackMethod: 'HobbitThemeCallback', // 全局安装函数（JSONP用）
  // },
  user: {
    tokenKey: 'token',
    userIdKey: 'vkuserid',
    studentIdKey: 'vkstudentid',
    tokenRecheckSeconds: 20 * 60,
    signupSourceKey: 'vkSignupSource',
  },
  log: {
    saSDK: 'https://s.vipkidstatic.com/fe-static/int/asset/pub/sensors-1_21_6.js',
    saUrl: 'https://sensorsdata.vipkid.com/sa?project=misc',
    product: 'intl',
    channelKey: 'channel', // URL中设置渠道的参数key
    channelLevelKey: 'chlevel', // URL中设置的渠道级别
    referralKey: 'referralcode', // URL中设置转介绍参数key
    consoleLog: false,
    defaultApiLogSampling: 10, // 默认api监控统计抽样率
  },
  fetch: {
    baseUrl: '',
    defaultTimeout: 1e4,
    cacheStoreName: 'FetchCache',
    cacheKeyPrefix: '20240703-1130',
    maxCacheCount: 50, // <=0则禁用缓存
    retryDelay: 1200, // <=0则禁用
    withCredentials: false, // 默认跨域鉴权开关
    idem: true, // 幂等请求
    mock: false, // 生产环境任何时刻都不建议开启mock测试，请保持关闭状态
  },
};
